<!-- ramka podświetlenia -->
<div class="frame" (click)="onBackgroundClick()"></div>

<!-- pasek akcji -->
<div class="ite-actions">
   <button class="action-btn edit-btn" (click)="openEditor()"  aria-label="Edytuj blok">
    <!-- <mat-icon>edit</mat-icon> -->a
  </button>

  <button class="action-btn delete-btn" (click)="deleteBlock()"  aria-label="Usuń blok">
    <!-- <mat-icon>delete</mat-icon> -->s
  </button>  
</div>
